@if (!showConfirmation) {
<div class="dialog-container">
  <label class="addInductionLabel" id="addInductionLabel">
    {{
      (!isEditMode ? "site_induction_add_header" : "site_induction_edit_header")
        | translate
    }}
  </label>
  <div class="divider"></div>
  @if (!isEditMode) {
  <form [formGroup]="inductionFormGroup">
    <div>
      <mat-form-field appearance="outline" fxFlex="100">
        <mat-label class="color-city-blue">{{
          "site_induction_add_entercompanyname_field" | translate
        }}</mat-label>
        <mat-select
          formControlName="brandName"
          (selectionChange)="selectedBrand($event.value)"
        >
          @for (brand of brands; track brand) {
          <mat-option [value]="brand">
            {{ brand.name }}
          </mat-option>
          }
        </mat-select>
        @if (hasError(inductionFormGroup, InductionFormGroupKeys.BRAND_NAME)) {
        <mat-error>{{ getError(inductionFormGroup, InductionFormGroupKeys.BRAND_NAME) }}</mat-error>
        }
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" fxFlex="100">
        <mat-label class="color-city-blue">{{
          "site_induction_add_enterinductionid_field" | translate
        }}</mat-label>
        <input
          matInput
          placeholder="{{
            'site_induction_add_enterinductionid_field' | translate
          }}"
          formControlName="inductionId"
          required
          id="input_inductionid"
        />
        @if (hasError(inductionFormGroup, InductionFormGroupKeys.INDUCTION_ID)) {
        <mat-error>{{ getError(inductionFormGroup, InductionFormGroupKeys.INDUCTION_ID) }}</mat-error>
        }
      </mat-form-field>
    </div>
  </form>
  } @if (isEditMode) {
  <form [formGroup]="inductionFormGroup">
    <div>
      <mat-form-field appearance="outline" fxFlex="100">
        <mat-label class="color-city-blue">{{
          "site_induction_edit_label_company" | translate
        }}</mat-label>
        <input matInput formControlName="brandName" id="input_brandName" />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" fxFlex="100">
        <mat-label class="color-city-blue">{{
          "site_induction_edit_label_inductionId" | translate
        }}</mat-label>
        <input
          matInput
          placeholder="{{
            'site_induction_add_enterinductionid_field' | translate
          }}"
          formControlName="inductionId"
          required
          id="input_inductionid"
        />
        @if (hasError(inductionFormGroup, InductionFormGroupKeys.INDUCTION_ID)) {
        <mat-error>{{ getError(inductionFormGroup, InductionFormGroupKeys.INDUCTION_ID) }}</mat-error>
        }
      </mat-form-field>
    </div>
  </form>
  }

  <div class="divider"></div>
  <div class="divider"></div>

  <button
    type="submit"
    id="register2_continue"
    mat-raised-button
    (click)="submitInduction()"
    [disabled]="disableSubmitButton()"
  >
    {{ "site_induction_add_submit" | translate }}
  </button>

  <div class="divider"></div>
  <button
    mat-stroked-button
    class="color-city-blue btn-border-color"
    (click)="dismissDialog()"
  >
    {{ "site_induction_add_cancel" | translate }}
  </button>
</div>
} @else {
<app-site-induction-confirmation
  [validationResult]="validationResult"
  [brandImageUrl]="getBrandImageUrl()"
  [isEditMode]="isEditMode"
  [inductionIdInput]="inductionFormGroup.get(InductionFormGroupKeys.INDUCTION_ID)?.value"
  [brandNameInput]="getSelectedBrandName()"
  (continue)="onConfirmationContinue()"
  (resubmit)="onConfirmationResubmit()"
></app-site-induction-confirmation>
}
